import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import ImgViewLg from 'components/common/FileController/ImgViewLg';
import { Card, Button } from 'antd';

@inject('orderStore')
@observer
class GoodsListNoUser extends Component {

  UNSAFE_componentWillMount() {
    this.props.orderStore.orderGoodsList('','','', true);
  }

  render() {
    const { goodsList } = this.props.orderStore;
    const { onSelect, detailGoods } = this.props;
    return (
      <Fragment>
        <h2>▶ 주문가능 유니폼</h2>
        <Card>
        {/* {goodsList !== undefined && goodsList !==null && goodsList.length === 0 && 
          <h4 style={{ color: 'red' }}>주문가능 한 유니폼이 없습니다.</h4>
        } */}
        {goodsList.map((item, idx)=>{
          return (
            <Card.Grid
              key={idx}
              hoverable={false} 
              className={
                (detailGoods !== null && detailGoods.gdCd !== undefined && detailGoods.gdCd !== null
                && item.gdCd !== undefined && item.gdCd !== null && detailGoods.gdCd === item.gdCd) 
                ? "item_unip_card on" : "item_unip_card"
              }
            >
              <Card
                title={item.gdNm}
                hoverable
                /* style={{ width: 150, height: 180 }} */
                cover={
                  item.gdImgUrlInfo_fileId !== undefined && item.gdImgUrlInfo_fileId !== null &&
                  item.gdDetailUrlInfo_fileId !== undefined && item.gdDetailUrlInfo_fileId !== null &&
                  <Fragment>
                    <ImgViewLg
                      viewGlass={true}
                      fileInfo={{
                        fileId: item.gdImgUrlInfo_fileId,
                        fileName: item.gdImgUrlInfo_fileName,
                        physicalName: item.gdImgUrlInfo_physicalName,
                        serverSubPath: item.gdImgUrlInfo_serverSubPath,
                      }}
                      /*width={100}
                      height={100}*/
                      detailFileInfo={{
                        fileId: item.gdDetailUrlInfo_fileId,
                        fileName: item.gdDetailUrlInfo_fileName,
                        physicalName: item.gdDetailUrlInfo_physicalName,
                        serverSubPath: item.gdDetailUrlInfo_serverSubPath,
                      }}
                    />
                  </Fragment>
                }
                actions={[<Button type="primary" onClick={()=>onSelect(item)} >선택</Button>]}
              >
                {/* <Card.Meta title={item.pGdNm} description={item.gdNm} /> */}
              </Card>
            </Card.Grid>
          );
        })}
        </Card>
      </Fragment>
    );
  }

}

export default GoodsListNoUser;
